import React from 'react';
import { styled } from 'styles';
import {
  Card,
  IntegrationName,
  IntegrationType,
  IntegrationDesc,
  IntegrationHeader,
} from './styles';

interface IntegrationCardProps {
  name: string;
  description: string;
  type: string;
  button: React.ReactNode;
  logo: React.ReactNode;
  live?: boolean;
}

export const ButtonContainer = styled.div`
  display: flex;
`;

export const IntegrationCard = ({
  name,
  logo,
  description,
  type,
  button,
}: IntegrationCardProps) => (
  <Card>
    <IntegrationHeader>{logo}</IntegrationHeader>
    <IntegrationName>{name}</IntegrationName>
    <IntegrationType>{type}</IntegrationType>
    <IntegrationDesc>{description}</IntegrationDesc>
    <ButtonContainer>{button}</ButtonContainer>
  </Card>
);
